class PlaceholderSuggestion extends HTMLElement {
    constructor() {
      super();
      this.cursor = "|";
      this.input = this.querySelector('input');
      this.suggestions = this.dataset.suggestions.split(',');
      this.originalPlaceholder = this.input.placeholder;
      this.currentIndex = 0;
      this.timer = null;
      this.cursorTimer = null;
      this.cursorVisible = true;
      this.cursorBlinkCount = 0;
      this.maxCursorBlinks = 5; // Anzahl der Blinkvorgänge des Cursors
      this.isVisible = false;
    }
  
    connectedCallback() {
      if (this.input) {
        this.input.placeholder = "";
        this.createIntersectionObserver();
        this.input.addEventListener('input', this.onUserInput.bind(this));
        this.input.addEventListener('focusout', this.onFocusOut.bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }
    }
  
    createIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.startTypingEffect();
          } else {
            this.isVisible = false;
            this.resetTypingEffect();
          }
        });
      });
      observer.observe(this.input);
    }
  
    startTypingEffect() {
      if (!this.isVisible) return;
      const word = [...this.suggestions[this.currentIndex]]; // Split string into characters, considering emojis
      let placeholderText = "";
      const loopTyping = () => {
        if (word.length > 0) {
          placeholderText += word.shift();
          this.input.setAttribute('placeholder', placeholderText);
          this.timer = setTimeout(loopTyping, 100);
        } else {
          this.cursorBlinkCount = 0;
          this.input.setAttribute('placeholder', placeholderText + this.cursor);
          this.startCursorBlink(() => {
            this.startDeletingEffect();
          });
        }
      };
      loopTyping();
    }
  
    startDeletingEffect() {
      if (!this.isVisible) return;
      const word = [...this.suggestions[this.currentIndex]]; // Split string into characters, considering emojis
      const loopDeleting = () => {
        if (word.length > 0) {
          word.pop();
          this.input.setAttribute('placeholder', word.join("") + (this.cursorVisible ? this.cursor : ""));
          this.timer = setTimeout(loopDeleting, 50);
        } else {
          this.currentIndex = (this.currentIndex + 1) % this.suggestions.length;
          this.startTypingEffect();
        }
      };
      loopDeleting();
    }
  
    startCursorBlink(callback) {
      if (this.cursorTimer) {
        clearInterval(this.cursorTimer);
      }
      this.cursorBlinkCount = 0;
      this.cursorTimer = setInterval(() => {
        if (this.cursorBlinkCount >= this.maxCursorBlinks) {
          clearInterval(this.cursorTimer);
          this.cursorTimer = null;
          this.cursorVisible = true;
          const currentPlaceholder = this.input.getAttribute('placeholder');
          if (currentPlaceholder) {
            this.input.setAttribute('placeholder', currentPlaceholder.replace(/\|?$/, ""));
          }
          if (callback) callback();
          return;
        }
        this.cursorVisible = !this.cursorVisible;
        const currentPlaceholder = this.input.getAttribute('placeholder');
        if (currentPlaceholder) {
          this.input.setAttribute('placeholder', currentPlaceholder.replace(/\|?$/, this.cursorVisible ? this.cursor : ""));
        }
        this.cursorBlinkCount++;
      }, 500);
    }
  
    stopCursorBlink() {
      if (this.cursorTimer) {
        clearInterval(this.cursorTimer);
        this.cursorTimer = null;
      }
      this.cursorVisible = true;
    }
  
    onUserInput() {
      if (this.input.value.trim() !== "") {
        this.resetTypingEffect();
      } else if (this.isVisible && !this.input.matches(':focus')) {
        this.startTypingEffect();
      }
    }
  
    resetTypingEffect() {
      clearTimeout(this.timer);
      this.stopCursorBlink();
      this.timer = null;
      this.input.setAttribute('placeholder', this.originalPlaceholder);
    }
  
    onFocusOut() {
      if (this.input.value.trim() === "" && this.isVisible) {
        this.startTypingEffect();
      }
    }
  
    onFocus() {
      if (this.input.value.trim() === "") {
        this.resetTypingEffect();
      }
    }
  }
  
  customElements.define('placeholder-suggestion', PlaceholderSuggestion);
  